'use client';

// import Balancer from 'react-wrap-balancer';
import { sanitize } from 'isomorphic-dompurify';
import Image, { StaticImageData } from 'next/image';
import Link, { LinkProps } from 'next/link';

import CallToActionImage from '@/assets/images/play-video-button-copy@2x.webp';
import { HeadingTwo } from '@/components/Typography/Heading';
import Paragraph from '@/components/Typography/Paragraph';

export interface CardStyleDoubleColumnBannerProps {
  headline: string;
  image: StaticImageData;
  description: string | Array<string>;
  button?: {
    link: LinkProps & { label?: string };
    image?: StaticImageData;
  };
  badgeImage?: StaticImageData;
}

export default function CardStyleDoubleColumnBanner(props: CardStyleDoubleColumnBannerProps) {
  const { headline, description: descriptionProp, button, badgeImage, image } = props;

  const description = Array.isArray(descriptionProp) ? descriptionProp : [descriptionProp];

  return (
    <div className="sm:mb-10 sm:px-[30px] sm:pb-[60px] sm:pt-[30px] md:mb-[125px] md:pb-0 lg:mx-auto lg:mb-0 lg:max-w-[1004px] lg:px-0 lg:pt-[130px] lg:pb-[150px]">
      <div className="grid sm:grid-cols-1 lg:-mx-[15px] lg:grid-cols-2">
        <div className={`order-1 lg:order-none lg:px-[15px]`}>
          <Image src={image} className="h-auto w-full sm:mt-[30px] lg:mt-0 lg:max-w-[487px]" alt="Girl and Dog" />
        </div>
        <div
          className={`lg:max-[558px] relative z-[2] rounded-lg bg-white sm:py-0 sm:shadow-none lg:mt-[60px] lg:-ml-[50px] lg:px-10 lg:pt-10 lg:pb-[30px] lg:shadow-[10px_10px_37px_-3px_rgba(0,0,0,.03)]`}
        >
          <HeadingTwo
            className="mb-[23px] font-circular-std-medium"
            dangerouslySetInnerHTML={{ __html: sanitize(headline ?? '') }}
          />

          <div className="mb-4">
            {description.map(text => (
              <Paragraph key={text} variant="light-gray" className="mb-8 last-of-type:mb-0">
                {text}
              </Paragraph>
            ))}
          </div>
          {button ? (
            <p className="mt-6">
              <Link {...button.link} className="transform-gpu duration-300 hover:text-primary hover:duration-300">
                <Image
                  className="mx-2 inline-block"
                  width={60}
                  src={button.image || CallToActionImage}
                  alt="call to action"
                />
                <p className="mx-2 inline-block">{button.link.label || 'LEARN MORE'}</p>
              </Link>
            </p>
          ) : null}
          {badgeImage ? (
            <Image className="absolute bottom-7 right-7" src={badgeImage} alt="badgeImage" width={134} />
          ) : null}
        </div>
      </div>
    </div>
  );
}
